(function () {
    "use strict";

    angular
        .module("app")
        .directive("toeComponentSearchHelp", ["SearchFactory", toeComponentSearchHelp]);

    function toeComponentSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.toeComponentKey = "";
                        scope.toeComponentDesc = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.toeComponentDesc === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.toeComponentSearch(scope.sapBrandId, function (toeComponent) {
                        scope.toeComponentKey = toeComponent ? toeComponent.ToeComponentKey : "";
                        scope.toeComponentDesc = toeComponent ? toeComponent.ToeComponentDesc : "";
                        scope.displayValue = scope.toeComponentDesc;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue]);
                };

                scope.displayValue = scope.toeComponentDesc;
                scope.prevDisplayValue = scope.displayValue;


                scope.$watch("toeComponentDesc", function (newValue) {
                    scope.displayValue = newValue;
                });
            },
            scope: { toeComponentKey: "=", toeComponentDesc: "=", readOnly: "=", required: "=", controlName: "@", sapBrandId: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

